
import './switch.component.scss'

const Switch = ({checked, onChange}) => (  <label className="switch">
        <input type="checkbox" checked={checked} {...{onChange}} />
        <span className="slider round"></span>
    </label> )

export default Switch;